import TicketCommentsRich from './TicketCommentsRich.vue';
export default TicketCommentsRich;
